// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I4Mu","textarea":"styles_textarea__3WFZu"};